<template>
  <div>
    <com-dialog
      :visible.sync="visible"
      width="1100px"
      :title="type === 'created' ? '新增' : '编辑'"
    >
      <div>
        <div class="flex items-center">
          <div class="form_item flex items-center">
            <div class="label">名称</div>
            <el-input style="width: 150px" v-model="form.name"></el-input>
          </div>
          <div class="form_item flex items-center ml-15px">
            <div class="label">是否有赠送</div>
            <el-select v-model="form.hasGive">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </div>
        </div>
        <div class="form_item mtb-15px">
          <div class="flex items-center">
            <div class="label">套餐设置</div>
            <el-button type="text" @click="handleAddCombo">添加</el-button>
          </div>
          <div class="flex flex-wrap">
            <div
              v-for="(item, index) in form.rechargePlanBeanList"
              :key="index"
              class="mb-15px relative price_wrapper flex flex-col justify-center w-500px mr-20px"
            >
              <div>
                <div class="flex flex-wrap items-center">
                  <div class="mb-10px mr-15px plr-15px ptb-15px combo_wrapper relative">
                    <div class="flex items-center mtb-10px">
                      <div class="label">充值金额</div>
                      <el-input
                        placeholder="请输入"
                        :value="item.sum"
                        @input="(val) => handleInput('sum', index, val)"
                        class="w-180px"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </div>
                    <div class="flex items-center mtb-10px" :style="{display: form.hasGive ? 'flex' : 'none'}">
                      <div class="label">赠送金额</div>
                      <el-input
                        placeholder="请输入"
                        :value="item.giveSum"
                        @input="(val) => handleInput('giveSum', index, val)"
                        class="w-180px"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </div>
                    <div class="flex items-center">
                      <div class="label">用户选择占比</div>
                      <el-input
                        placeholder="请输入"
                        :value="item.ratio"
                        @input="(val) => handleInput('ratio', index, val)"
                        class="w-180px"
                      >
                        <template slot="append">%</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="remove" @click="removeCombo(item, index)">
                <i class="el-icon-remove"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-15px flex justify-end">
          <el-button @click="close"> 取消 </el-button>
          <el-button type="primary" @click="handleSubmit"> 确定 </el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { add, detail, edit } from '@/api/recharge-package'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      type: 'created',
      form: {
        name: '',
        hasGive: '',
        rechargePlanBeanList: []
      }
    }
  },
  methods: {
    open(opt) {
      const { code, type } = opt
      this.type = type
      this.form = {}

      if (type === 'created') {
        this.form.rechargePlanBeanList = [
          {
            sum: '',
            giveSum: '',
            ratio: ''
          }
        ]
      }
      if (code) {
        this.getDetail(code)
      }
      this.visible = true
    },
    close() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
      }, 200)
    },

    getDetail(code) {
      detail({ code }).then((res) => {
        const { rechargePlanBatch } = res.data
        this.form = utils.deepClone(rechargePlanBatch)
        this.$forceUpdate()
      })
    },
    handleAdd() {
      const params = { ...this.form }
      console.log('新增 :>> ', params)
      add(utils.cleanObject(params)).then((res) => {
        if (res.status === 200) {
          this.$message.success('操作成功')
          this.$emit('success')
          this.close()
        }
        console.log('res :>> ', res)
      })
    },
    handleEdit() {
      console.log('编辑 :>> ', this.form)
      const params = { ...this.form }
      edit(params).then(() => {
        this.$message.success('操作成功')
        this.$emit('success')
        this.close()
      })
    },
    handleSubmit() {
      if (this.type === 'edit') {
        this.handleEdit()
        return
      }
      this.handleAdd()
    },
    handleInput(type, index, val) {
      this.form.rechargePlanBeanList[index][type] = val
      this.$forceUpdate()
    },
    // 添加套餐设置
    handleAddCombo() {
      const params = {
        sum: '',
        giveSum: '',
        ratio: ''
      }
      this.form.rechargePlanBeanList.push(params)
      this.$forceUpdate()
      console.log('this.form :>> ', this.form)
    },
    // 移除套餐设置
    removeCombo(row, index) {
      console.log('row :>> ', row, index)
      this.form.rechargePlanBeanList.splice(index, 1)
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.form_item {
  .label {
    width: 100px;
  }
  .input {
    .el-input__inner {
      width: 300px !important;
    }
  }

  .price_wrapper {
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    padding-left: 16px;
    .remove {
      position: absolute;
      top: -10px;
      right: -10px;
      cursor: pointer;
    }
  }
}
</style>
